import api from "./axios";

export const fetchPublicPage = async (storeId) => {
  const response = await api.get(`/public/pages/${storeId}`);
  return response.data;
};

export const fetchPageByDomain = async (domain) => {
  const response = await api.get(
    `/public/pages/find_by_domain?domain=${domain}`,
  );
  return response.data;
};

export const fetchPublicForm = async (formId) => {
  const response = await api.get(`/public/forms/${formId}`);
  return response.data;
};

export const fetchFirstPublicForm = async (storeId) => {
  const response = await api.get(`/public/forms/${storeId}/first`);
  return response.data;
};

export const fetchPublicCustomer = async (customerId) => {
  const response = await api.get(`/public/customers/${customerId}`);
  return response.data;
};

export const fetchPhoneCode = async () => {
  const response = await api.get("/public/phone_codes/detect");
  return response.data;
};
